<template>
  <div>
    <b-row align-v="center">
      <b-col class="col-md-6" v-if="revendedoraSelecionada">
        <h4>{{ revendedoraSelecionada.label }}</h4>
      </b-col>
      <b-col class="text-right">
        <b-button v-if="!isBonificacao && !cash_back" :disabled="kitP" size="sm" variant="primary" class="md-3 mr-3"
          @click="selecionaRevendedora()">Selecionar Revendedora</b-button>
        <b-button :disabled="kitP" variant="outline-primary" size="sm" @click="showModalFileUpload"
          v-b-popover.hover.top="'Importar Arquivo'">
          <i class="fas fa-upload"></i>
        </b-button>
        <b-button :disabled="kitP" variant="outline-primary" size="sm" @click="aproveitarTodoEstoque"
          v-b-popover.hover.top="'Aproveitar Todo estoque'">
          <i class="fas fa-box-open"></i>
        </b-button>
        <b-button :disabled="kitP" variant="outline-primary" size="sm" v-b-popover.hover.top="'Limpar uso do Estoque'"
          @click="limparUsoEstoque">
          <i class="fas fa-broom"></i>
        </b-button>
      </b-col>
    </b-row>
    <b-row align-v="end" class="mb-2">
      <b-col class="col-md-2">
        <div v-if="classe !== 'H'">
          <label for=""> Desconto % </label>
          <b-form-input :disabled="kitP" placeholder="Desconto" v-mask="'###'" v-model="descontoDoPedido" />
        </div>
      </b-col>
      <b-col align-h="right" align-self="end" class="text-right">
        <b-list-group horizontal>
          <b-list-group-item variant="light" class="text-center">
            <i class="fas fa-cart-plus"></i>
            <span>Itens <b-badge variant="info"> {{ qtdItens }} </b-badge></span></b-list-group-item>
          <b-list-group-item variant="light" class="text-center">
            <i class="fas fa-cart-plus"></i>
            <span>Produtos
              <b-badge variant="info">{{ qtdProdutos }}</b-badge></span>
          </b-list-group-item>
          <b-list-group-item variant="primary" class="text-center"><i class="far fa-money-bill-alt"></i>
            <span>
              Total <b-badge variant="info">R$ {{ valorTotal }}</b-badge>
            </span>
          </b-list-group-item>
        </b-list-group>
      </b-col>
      <b-col class="text-right" v-if="kitP">
        <h3>Pedido Kit Personalizado!</h3>
      </b-col>
      <b-col class="text-right" v-else-if="isBonificacao">
        <h3>Pedido Bonificado</h3>
      </b-col>
      <b-col class="text-right bg-danger pedido-cash mr-2" v-else-if="cash_back && cash_back.id">
        <h5 class="mt-1 mr-1">
          Pedido CashBack no valor de R$
          {{ cash_back.cashback.toString().replace(".", ",") }}
        </h5>
      </b-col>
      <b-col class="text-right bg-danger pedido-cash mr-2" v-else-if="pedidoEstoque">
        <h5 class="mt-1 mr-1">
          Pedido de Estoque
        </h5>
      </b-col>
      <b-col class="text-right bg-danger pedido-cash mr-2" v-else-if="pedidoLancamento">
        <h5 class="mt-1 mr-1">
          Pedido de Lançamento
        </h5>
      </b-col>
    </b-row>

    <!--  <div class="row mt-3">
        <div class="col-12 text-right preview-value">
        </div>
    </div> -->
    <!-- ########################################## fim row head Pedido ######################## -->

    <div class="row">
      <div class="col-12">
        <div class="card border border-primary">
          <div class="d-flex justify-content-center mt-3">
            <div v-if="loading" class="spinner-border text-primary" style="width: 3rem; height: 3rem" role="status">
            </div>
          </div>
          <div class="card-body" v-show="!loading">
            <b-row align-v="end">
              <b-col cols="4">
                <label for="">Produto</label>
                <input id="input-codigo-produto" type="number" class="form-control" v-model="codigo"
                  @keyup="searchProduto" @keyup.enter="changeFocusCodigo" />
              </b-col>
              <b-col cols="2">
                <label for="">Quantidade</label>
                <input id="input-quantidade" type="text" v-mask="'######'" class="form-control" v-model="quantidade"
                  @keyup.enter="addPedido" />
              </b-col>
              <b-col cols="2" v-if="getEstoqueDisponivel > 0 && !cash_back">
                <label for="">Usar do Estoque</label>
                <input type="text" min="0" v-mask="'####'" class="form-control" v-model="usarEstoque"
                  @keyup.enter="addPedido" @keyup="keyUpValidateEstoque" />
              </b-col>
              <b-col>
                <b-button variant="success" class="align-buttom" @click="addPedido">
                  <i class="fa fa-plus"></i> Adicionar
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col :class="[getEstoqueDisponivel > 0 ? 'col-md-6 col-sm-12' : 'col-12']">
                <small>
                  <p class="text-info"><b> {{ labelProduto }}</b></p>
                </small>
              </b-col>
              <b-col v-if="getEstoqueDisponivel > 0">
                <div v-if="getEstoqueDisponivel > 0">
                  <small class="text-primary">
                    Estoque: {{ getEstoqueDisponivel }}
                  </small>
                  <h5></h5>
                </div>
              </b-col>
            </b-row>
            <div class="row mt-2">
              <div class="col-md-12" style="overflow: auto">
                <b-table-simple caption-top hover small stacked="sm">
                  <template #table-caption>
                    <div>
                      Aproveitamento do estoque
                      <b-badge variant="info">{{
                        qtdAproveitadoEstoque
                      }}</b-badge>
                    </div>
                    <div v-if="pedidoMinimo">
                      {{
                        `O Valor do pedido mínimo é de R$ ${parseFloat(
                          pedidoMinimo.valor
                        )
                          .toFixed(2)
                          .toString()
                          .replace(".", ",")}`
                      }}
                    </div>
                  </template>
                  <b-thead head-variant="light">
                    <b-tr>
                      <b-th class="text-center">Código</b-th>
                      <b-th>Produto</b-th>
                      <b-th class="text-center" v-if="classe === 'H'">
                        Desconto
                      </b-th>
                      <b-th class="text-center">Preço R$</b-th>
                      <b-th class="text-center">Qtd</b-th>
                      <b-th class="text-center">Estoque Disp.</b-th>
                      <b-th class="text-center">Uso Estoque</b-th>
                      <b-th class="text-center">Total</b-th>
                      <b-th>&nbsp;</b-th>
                    </b-tr>
                  </b-thead>

                  <b-tbody>
                    <b-tr v-for="(pedido, index) in pedidosOrdered" :class="{ 'first-row': index === 0 }" :key="index">
                      <b-td class="text-center" stacked-heading="codigo">{{
                        pedido.codigo
                      }}</b-td>

                      <b-td stacked-heading="Produto">{{
                        produtos[pedido.codigo].nome
                      }}</b-td>

                      <b-td class="text-center" stacked-heading="desconto" v-if="classe === 'H'">
                        {{
                          parseFloat(produtos[pedido.codigo].desconto)
                            .toFixed(2)
                            .replace(".", ",")
                        }}
                      </b-td>

                      <b-td class="text-center" stacked-heading="Preço">
                        {{
                          parseFloat(produtos[pedido.codigo].preco)
                            .toFixed(2)
                            .replace(".", ",")
                        }}
                      </b-td>

                      <b-td class="text-center" stacked-heading="Qtd">{{
                        pedido.quantidade
                      }}</b-td>

                      <b-td class="text-center" stacked-heading="Estoque Disp.">
                        {{ estoqueDisponivelComputed[pedido.codigo] ? estoqueDisponivelComputed[pedido.codigo] : '' }}
                      </b-td>

                      <b-td class="text-center" stacked-heading="Uso Estoque">
                        {{ pedido.aproveitadoEstoque }}
                      </b-td>

                      <b-td class="text-center" stacked-heading="Total">
                        {{
                          parseFloat(
                            parseFloat(
                              produtos[pedido.codigo].preco -
                              produtos[pedido.codigo].desconto
                            ) * pedido.quantidade
                          )
                            .toFixed(2)
                            .replace(".", ",")
                        }}
                      </b-td>
                      <!-- <b-td class="text-center" stacked-heading="Brinde">
                        {{ produtos[pedido.codigo].brinde ? "Sim" : "Não" }}
                      </b-td>-->
                      <b-td class="text-center">
                        <b-button title="Editar" v-if="showEditar(pedido.codigo)" variant="primary"
                          @click="showModalEdit(pedido.codigo)">
                          <i class="fa fa-edit"></i>
                        </b-button>
                        <b-button title="Deletar" variant="outline-danger"
                          @click.prevent="showDeleteItem(pedido.codigo)">
                          <i class="fas fa-trash-alt"></i>
                        </b-button>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
              <div class="col-12 text-right">
                <button class="btn btn-danger" @click="showModalDestroyPedido" v-if="getIdPedido > 0">
                  <i class="fas fa-trash-alt"></i> Deletar
                </button>
                <button v-if="!profile.pdf" class="btn btn-success" @click.prevent="savePedido">
                  <i class="fa fa-save"></i>
                  {{ kitP ? "Salvar e Enviar " : "Salvar" }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!------------------------- Modal Selecionar Revendedora ----------------------------- -->
    <b-modal 
      v-model="modalRevendedora" 
      hide-footer
      centered
      no-close-on-backdrop 
      hide-header 
      no-close-on-esc
      no-enforce-focus 
      no-stacking
    >
      <label>Selecione a Revendedora:</label>
      <b-form-input
        :class="['text-left']"
        placeholder="Digite o nome do revendedor(a)"
        autocomplete="off"
        v-model="searchRevendedora"
        @blur="visibleResult = false"
        @focus="visibleResult = true"
      ></b-form-input>
      <transition name="fade">
        <div class="search-result text-center border rounded shadow" v-show="visibleResult">
          <b-row
            v-for="(revendedora, index) in ObjListaDeRevendedoras"
            :key="index"
            :class="['py-2', 'm-0', 'result-list', (index+1 != ObjListaDeRevendedoras.length ? 'border-bottom' : '')]"
            @click="changeRevendedora(revendedora)"
          >
            <b-col cols="10" class="product-name text-left">
              {{capitalize(revendedora.label)}}
            </b-col>

          </b-row>

          <div v-if="loadingRevenda">
            <b-row v-for="load in 5" :key="load" :class="['py-2', 'm-0', (load != 5 ? 'border-bottom' : ''), 'justify-content-center']" >
              <b-col class="bressay-bold-italic product-name p-0 d-flex justify-content-start align-items-center">
                <b-skeleton animation="wave" class="ml-3" :width="`${numeroAleatorio(40, 60)}%`"></b-skeleton>
              </b-col>
            </b-row>
          </div>
          <p class="py-2 m-0" style="font-size: 16px;" v-else-if="ObjListaDeRevendedoras.length == 0">Nenhum revendedora(a) encontrado!</p>
        </div>
      </transition>
      <!--<b-button title="Adicionar Revendedora" class="float-rigth" variant="primary" size="sm" @click="openCadastro"><i class="fa fa-user-plus"></i></b-button>-->
      <!-- <v-select 
        class="mt-2" 
        label="label"
        placeholder="Digite para buscar a consultora..."
        @search="searchRevendedora" 
        v-model="revendedoraSelecionadaModal" 
        :options="ObjListaDeRevendedoras"
        @change="validaCadastro"
      >
        <template #no-options>
          <span>Nenhuma revendedora encontrada.</span>
        </template>

        <template #option="{ label, loadingRevenda }">
            <template v-if="loadingRevenda">
                <b-skeleton width="85%"></b-skeleton>
            </template>
            <template v-else>
                {{ label }}
            </template>
        </template>
      </v-select> -->

      <b-alert class="mt-3" show v-if="classe === 'G' && !valido" :variant="cpfIsValid">
        CPF da revendedora é inválido, por favor corrija o CPF antes de prosseguir.
      </b-alert>

      <b-button class="mt-3" variant="danger" @click="goBack">
        Cancelar <i class="fas fa-times"></i>
      </b-button>
    </b-modal>

    <!---------------------------------------- Modal Adicionar Revendedora ---------------------------------------->
    <b-modal v-model="isCadastro" size="xl">
      <b-card v-if="profile.endereco">
        <cadastro-revendedora :disabled="kitP" :lista_revendedoras="revendedoras" :revendedora="{}"
          :classe_distribuidor="classe" :meu_estado="profile.endereco.cidade.estado.uf
            ? profile.endereco.cidade.estado.uf
            : ''
            " />
      </b-card>
      <template #modal-footer>
        <b-button variant="primary" size="sm" @click="saveRevendedora">
          <i class="fa fa-save"></i> Salvar
        </b-button>
        <button variant="danger" size="sm" @click="isCadastro = false">
          cancelar
        </button>
      </template>
    </b-modal>
    <!---------------------------------------- Modal Edit ---------------------------------------->
    <b-modal v-model="modalEdit" size="lg">
      <b-card>
        <b-card-body>
          <b-row>
            <div class="fom-group col-md-6">
              <label for="">Quantidade</label>
              <input type="text" v-mask="'####'" class="form-control" v-model="quantidade" @focus="searchProduto"
                @keydown.enter="updatePedido" />
            </div>

            <div class="fom-group col-md-6" v-if="estoqueDisponivelEdit > 0 || usarEstoque > 0">
              <label for="">Usar do Estoque</label>
              <input type="text" v-mask="'####'" class="form-control" v-model="usarEstoque" @focus="searchProduto"
                @keydown.enter="updatePedido" />
              <p>Disponível: {{ estoqueDisponivelEdit }}</p>
            </div>

            <div class="col-md-12 container-btn text-center"></div>
          </b-row>
        </b-card-body>
      </b-card>
      <template #modal-header>
        <h4 class="modal-title" id="exampleModalLabel">
          {{ labelProduto }}
        </h4>
      </template>
      <template #modal-footer>
        <b-button variant="success" size="sm" @click="updatePedido">
          <i class="fa fa-save"></i> Salvar
        </b-button>
        <b-button variant="warning" size="sm" @click="deletePedido">
          <i class="fas fa-trash-alt"></i> Deletar
        </b-button>
        <b-button variant="danger" size="sm" @click="modalEdit = false">
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <!------------------------------------------------------ Modal File Upload ----------------------------- -->
    <b-modal v-model="modalFileUpload" title="Importar Pedidos" size="lg">
      <b-card>
        <div class="row">
          <div class="col-md-12" v-if="pedidosImportados.length === 0">
            <div class="form-group">
              <label for="">Escolha o Arquivo</label>
              <input type="file" class="form-control" @change="changeFile" />
            </div>
            <div class="col-md-12 text-center">
              <button class="btn btn-success" @click.prevent="sendFilePedidos">
                <i class="fa fa-send"></i> Enviar
              </button>
            </div>
          </div>

          <div class="col-md-12 resumo-importacao" v-if="pedidosImportados.length > 0">
            <table class="table table-responsive table-bordered table-striped">
              <thead>
                <tr>
                  <th>Produto</th>
                  <th class="text-center">Quantidade</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in pedidosImportados" :key="index">
                  <td v-if="produtos[item.codigo]">
                    {{ produtos[item.codigo] ? produtos[item.codigo].nome : "Sem estoque" }}
                  </td>
                  <td v-if="produtos[item.codigo] && produtos[item.codigo].disponivel === true" class="text-center">
                    {{ item.quantidade }}
                  </td>
                  <td class="text-danger text-center"
                    v-else-if="produtos[item.codigo] && !produtos[item.codigo].disponivel">
                    <small> SEM ESTOQUE </small>
                  </td>
                  <td v-if="!produtos[item.codigo]">
                    {{ item.codigo }}
                  </td>
                  <td class="text-center text-danger" v-if="!produtos[item.codigo]">INDISPONIVEL</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </b-card>
      <template #modal-footer>
        <button class="btn btn-primary" v-if="pedidosImportados.length > 0" @click="addImportados">
          <i class="fa fa-save"></i> Salvar
        </button>
        <b-button variant="danger" @click="modalFileUpload = false">Cancelar</b-button>
      </template>
    </b-modal>

    <!-- Modal de pedidos em aberto -->
    <b-modal v-model="modalPedidosAbertos" title="" size="lg" hide-header-close no-close-on-backdrop no-close-on-esc>
      <b-card>
        <b-row class="mb-3">
          <h5>
            Existe pedido(s) em aberto para esta revendedora na campanha atual !
          </h5>
        </b-row>
        <b-row>
          <b-table :items="pedidosAbertos" :fields="headerPedidosAbertos" stacked="md" head-variant="dark" hover
            responsive outlined bordered small>
            <template #cell(editar)="row">
              <b-button size="sm" variant="warning" @click="editarPedido(row.item)"><i class="fa fa-edit"></i> Editar
              </b-button>
            </template>
          </b-table>
        </b-row>
      </b-card>
      <template #modal-header>
        <h4>{{ revendedoraSelecionada.label }}</h4>
      </template>
      <template #modal-footer>
        <b-button variant="primary" size="sm" @click="modalPedidosAbertos = false">Novo Pedido</b-button>
        <b-button variant="danger" size="sm" @click="cancelarEditaPedido()">Cancelar</b-button>
      </template>
    </b-modal>
    <!-- Modal Incentivo -->
    <b-modal size="xl" v-model="modalIncentivo">
      <template #modal-header>
        <h4>
          <span>Valor total do incentivo: R$
            {{ saldoIncentivo.replace(".", ",") }}</span>
        </h4>
      </template>
      <b-card>
        <b-row class="mt-1 mb-1">
          <b-col class="col-md-12">
            <b-alert variant="success" show>Itens adicionados aqui, não são cobrados!</b-alert>
          </b-col>
        </b-row>
        <b-row align-v="end">
          <b-col class="col-md-4">
            <label for="">Produto</label>
            <b-form-input size="sm" placeholder="Produto" type="search" class="form-control"
              v-model="codigoProdutoIncentivo" @keyup="searchProdutoIncentivo"></b-form-input>
          </b-col>
          <b-col class="col-md-2">
            <label for="">Quantidade</label>
            <b-form-input size="sm" v-model="qtdProdutoIncentivo" placeholder="Quantidade"></b-form-input>
          </b-col>
          <b-col>
            <b-button size="sm" variant="success" @click="addIncentivo()"><i class="fas fa-plus"></i>
              Adicionar</b-button>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <span v-if="incentivoSelecionado">
              <h4>Produto:</h4>
            </span>
            <span v-if="incentivoSelecionado" class="text-success">
              {{ incentivoSelecionado.codigo }} -
              {{ incentivoSelecionado.nome }} - R$
              {{ incentivoSelecionado.preco.replace(".", ",") }} cada
            </span>
            <span class="text-danger" v-else>
              Produto não encontrado ou não encaixa na regra do incentivo
            </span>
          </b-col>
        </b-row>
        <b-row>
          <b-table v-show="pedidosIncentivoTable.length > 0" striped hover :fields="fields"
            :items="pedidosIncentivoTable">
            <template #cell(actions)="row">
              <b-button size="sm" title="Remover Item" variant="danger" @click="removerItemIncentivo(row.item)"><i
                  class="fas fa-trash"></i></b-button>
            </template>
          </b-table>
        </b-row>
        <b-row align-h="end">
          <span v-if="totalPedidoIncentivo > 0">
            <b>Total:
              {{
                parseFloat(totalPedidoIncentivo).toFixed(2).replace(".", ",")
              }}
            </b>
          </span>
        </b-row>
      </b-card>

      <template #modal-footer>
        <b-button variant="primary" size="sm" @click="saveBrinde"><i class="fas fa-check"></i>
          <span v-if="totalPedidoIncentivo > 0">Salvar Pedido</span>
          <span v-else>Salvar Pedido Sem Brinde</span>
        </b-button>
        <b-button variant="danger" size="sm" @click="modalIncentivo = false">Cancelar</b-button>
      </template>
    </b-modal>
    <!-------------------------- Kit Personalizado -------------------------->
    <!-- <kit-personalizado v-if='kitP' kit="kitP" />  -->
  </div>
</template>

<script>
import vSelect from "vue-select";
import validatePedidoMinimo from "./modules/validate_pedido_minimo.js";
import CadastroRevendedora from "../../revendedora/form.vue";

const validar = (cpf) => checkAll(prepare(cpf));
const notDig = (i) => ![".", "-", " "].includes(i);
const prepare = (cpf) => cpf.trim().split("").filter(notDig).map(Number);
const is11Len = (cpf) => cpf.length === 11;
const notAllEquals = (cpf) => !cpf.every((i) => cpf[0] === i);
const onlyNum = (cpf) => cpf.every((i) => !isNaN(i));

const calcDig = (limit) => (a, i, idx) => a + i * (limit + 1 - idx);
const somaDig = (cpf, limit) => cpf.slice(0, limit).reduce(calcDig(limit), 0);
const resto11 = (somaDig) => 11 - (somaDig % 11);
const zero1011 = (resto11) => ([10, 11].includes(resto11) ? 0 : resto11);

const getDV = (cpf, limit) => zero1011(resto11(somaDig(cpf, limit)));
const verDig = (pos) => (cpf) => getDV(cpf, pos) === cpf[pos];

const checks = [is11Len, notAllEquals, onlyNum, verDig(9), verDig(10)];
const checkAll = (cpf) => checks.map((f) => f(cpf)).every((r) => !!r);

export default {
  props: {
    pedido_estoque: {
      type: String,
      default: 0,
    },
    pedido_lancamento: {
      type: String,
      default: 0,
    },
    pedido_id: {
      type: String,
      default: "",
    },
    cashback: {
      type: String,
      default: null,
    },
    revendedora_id: {
      type: [Number, String],
      default: -1,
    },
  },
  /* props: ["pedido_id"], */
  components: {
    vSelect,
    CadastroRevendedora,
  },
  data() {
    return {
      cash_back: this.cashback ? JSON.parse(this.cashback) : null,
      pedido_id_local: this.pedido_id,
      modalEdit: false,
      produtosIncentivo: [],
      codigoProdutoIncentivo: null,
      qtdProdutoIncentivo: "",
      pedidosIncentivo: {},
      pedidosIncentivoTable: [],
      totalPedidoIncentivo: 0,
      valorTotalIncentivo: 0,
      incentivoAdicionado: false,
      fields: [
        {
          label: "",
          key: "actions",
        },
        {
          label: "Código",
          key: "codigo",
        },
        {
          label: "Produto",
          key: "nome",
        },
        {
          label: "Quantidade",
          key: "quantidade",
        },
        {
          label: "Preço",
          key: "preco",
          formatter: (value) => {
            return value.replace(".", ",");
          },
        },
      ],
      kitP: false,
      isCadastro: false,
      modalFileUpload: false,
      modalRevendedora: false,
      modalPedidosAbertos: false,
      headerPedidosAbertos: [
        {
          label: "",
          key: "editar",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Itens",
          key: "quantidade",
        },
        {
          label: "Criação",
          key: "created_at",
          formatter: (value) => {
            return moment(value).format("DD/MM/YY");
          },
          sortable: true,
        },
      ],
      valido: true,
      visibleResult: false,
      showAlert: false,
      pedidosAbertos: [],
      pedidoMinimo: {},
      incentivoSelecionado: null,
      produtos: {},
      loadingRevenda: false,
      produtosAdicionados: [],
      estoque: {},
      codigo: "",
      quantidade: "",
      labelProduto: "",
      classe: "",
      revendedoraSelecionadaModal: null,
      revendedoraSelecionada: null,
      descontoDoPedido: 0,
      pedidos: {},
      usarEstoque: 0,
      estoqueDisponivelEdit: 0,
      idPedido: 0,
      isBonificacao: false,
      filePedidos: null,
      pedidosImportados: [],
      revendedora_id_local: null,
      revendedoras: [],
      showBoxRevendedora: false,
      adicionandoImportados: false, //flag para não salvar automático quando estiver adicionado de importação
      maxOrder: 0,
      warnnings: [],
      numcpf: 0,
      erroProduto: false,
      searchRevendedora: '',
      loading: false,
      campanhaAtual: "",
      modalIncentivo: false,
      profile: {
        id: null,
        name: "",
        distribuidor: null,
        classe: null,
        codigo: null,
        endereco: {
          cidade: {
            id: null,
            estado: {
              id: null,
              uf: "",
            },
          },
        },
      },
    };
  },
  watch: {
    "searchRevendedora"(newVal) {
      this.revendedoras = [];
      this.revendedoraSelecionadaModal = null
      this.getRevendedoras(newVal);
    },
    pedidosIncentivoTable() {
      this.totalPedidoIncentivo = 0;
      this.pedidosIncentivoTable.forEach((el) => {
        this.totalPedidoIncentivo += el.preco * el.quantidade;
      });
    },
  },
  methods: {
    capitalize(string){
      return string.toLowerCase().replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
    },
    numeroAleatorio(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    showEditar(codigo) {
      let val = false
      if ((this.produtos[codigo] && this.produtos[codigo].disponivel) && (this.pedidos[codigo].aproveitadoEstoque <= 0)) {
        val = true
      }
      return val
    },
    saveBrinde() {
      const vm = this;
      $.extend(vm.pedidos, vm.pedidosIncentivo);
      vm.modalIncentivo = false;
      vm.incentivoAdicionado = true;
      vm.confirmaSavePedido();
    },
    removerItemIncentivo(item) {
      const vm = this;
      const codigo = item.codigo;
      Reflect.deleteProperty(vm.pedidosIncentivo, codigo);
      vm.pedidosIncentivoTable = Object.keys(vm.pedidosIncentivo).map((el) => {
        return vm.pedidosIncentivo[el];
      });
    },
    addIncentivo() {
      const vm = this;
      if (
        !vm.qtdProdutoIncentivo ||
        vm.qtdProdutoIncentivo == "" ||
        !vm.incentivoSelecionado ||
        vm.incentivoSelecionado == {}
      ) {
        return;
      }
      if (vm.incentivoSelecionado) {
        let totalPedidoIncentivos =
          vm.totalPedidoIncentivo +
          parseFloat(vm.incentivoSelecionado.preco * vm.qtdProdutoIncentivo);
        if (totalPedidoIncentivos > vm.saldoIncentivo) {
          return vm.$swal({
            icon: "warning",
            title: "Atenção!",
            text: "O valor total não pode ultrapassar o valor do incentivo!",
            showCancelButton: false,
            confirmButtonText: "Ok",
          });
        }
        let pedido = {};
        pedido.quantidade = parseInt(vm.qtdProdutoIncentivo);
        pedido.aproveitadoEstoque = 0;
        pedido.codigo = "B" + vm.incentivoSelecionado.codigo;
        pedido.nome = vm.incentivoSelecionado.nome;
        pedido.preco = vm.incentivoSelecionado.preco;
        pedido.produto_id = vm.incentivoSelecionado.produto_id;
        pedido.brinde = true;
        vm.$set(vm.pedidosIncentivo, pedido.codigo, pedido);
        vm.incentivoSelecionado = null;
        vm.qtdProdutoIncentivo = "";
        vm.codigoProdutoIncentivo = null;

        vm.pedidosIncentivoTable = Object.keys(vm.pedidosIncentivo).map(
          (el) => {
            return vm.pedidosIncentivo[el];
          }
        );
      }
    },
    searchProdutoIncentivo() {
      const vm = this;
      if (vm.codigoProdutoIncentivo.length > 3) {
        return (vm.incentivoSelecionado = vm.produtosIncentivo.find((el) => {
          if (vm.codigoProdutoIncentivo == el.codigo) {
            return el;
          }
        }));
      } else {
        vm.incentivoSelecionado = null;
      }
    },
    async validaKitPersonalizado() {
      $(".loading").show();
      const vm = this;
      await axios
        .get("/distribuidor/kitpersonalizado")
        .then((response) => {
          vm.kitP = response.data;
          if (response.data) {
            vm.getRevendedoras();
          }
        })
        .catch((erro) => {
          $(".loading").hide();
          console.log(erro);
          alert(erro);
        });
    },

    selecionaRevendedora() {
      const vm = this;
      vm.$swal({
        icon: "warning",
        title: "Atenção!",
        text: "Deseja realmente trocar a revendedora deste pedido?",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sim",
      }).then((response) => {
        if (response.isConfirmed) {
          vm.modalRevendedora = true;
        }
      });
    },
    editarPedido(pedido) {
      const vm = this;
      if (vm.classe === "G") {
        axios
          .post("/distribuidor/pedidos/incentivo/excluir/" + pedido.id)
          .then((response) => {
            window.location = "/distribuidor/pedidos/" + pedido.id + "/edit";
          });
      } else {
        window.location = "/distribuidor/pedidos/" + pedido.id + "/edit";
      }
    },
    cancelarEditaPedido() {
      if (!this.kitP) {
        this.modalRevendedora = true;
        this.modalPedidosAbertos = false;
      }
    },
    saveRevendedora() {
      this.isCadastro = false;
    },
    openCadastro() {
      this.isCadastro = true;
    },

    /*############################## Métodos Load ##################################*/
    loadPedido() {
      this.loading = true;
      if (!this.pedido_id_local || parseInt(this.pedido_id_local) <= 0) {
        this.loading = false;
        let revenda = parseInt(this.revendedora_id);
        if (revenda > -1) {
          this.loadRevendedoraById(revenda);
          return;
        }
        if (!this.kitP && !this.cash_back) {
          this.modalRevendedora = true;
        }
        this.showBoxRevendedora = true;
        return;
      }
      this.erroProduto = false;
      $(".loading").show();
      const vm = this;
      axios
        .get("/distribuidor/pedidos/" + vm.pedido_id_local)
        .then((response) => {
          let data = response.data;
          vm.revendedora_id_local = data.pedido.revendedora.id;
          vm.revendedoraSelecionada = {
            value: data.pedido.revendedora.id,
            label: data.pedido.revendedora.nome,
          };

          vm.pedidos = Object.assign({}, vm.pedidos, data.itens);

          if (data.pedido.cash_back && !vm.cash_back) {
            vm.cash_back = data.pedido.cash_back;
          }
          vm.descontoDoPedido = data.pedido.desconto;
          vm.isBonificacao = data.pedido.bonificacao;
          vm.addOrder();

          if (data.warnning.length > 0) {
            vm.warnnings = data.warnning;
            $("#modalWarnnings").modal();
          }
          vm.loading = false;
          $(".loading").hide();
        })
        .catch((error) => {
          console.log(error);
          alert("Falha ao carregar o pedido.");
          window.location.href = "/distribuidor/pedidos";
          vm.loading = false;
          $(".loading").hide();
        });
    },
    loadPedidoMinimo() {
      var vm = this;
      $(".loading").show();
      axios
        .get("/distribuidor/pedidominimo")
        .then((response) => {
          vm.pedidoMinimo = response.data;
          $(".loading").hide();
        })
        .catch(function (error) {
          alert("Erro ao carregar Pedido Minimo");
          console.log(error);
          $(".loading").hide();
        });
    },
    getRevendedoras(newVal) {
      const vm = this;
      vm.loadingRevenda = true
      axios
        .get("/distribuidor/revendedora/buscar", {params: {
            'name': newVal,
            'max': 5
          }
        })
        .then((response) => {
          vm.showAlert = true;
          if (vm.classe === "H" || vm.kitP || vm.cash_back) {
            var find = response.data.find((el) => {
              return el.nome == this.profile.name;
            });

            if(find){
              vm.revendedoraSelecionada = {
                value: find.id,
                label: find.nome,
              };
            }else{
              vm.$swal(
                "Atenção",
                "Revendedora não encontrada, por favor entre em contato com o suporte.",
                "error"
              );

              return
            }
            // vm.revendedoras.push(response.data[0])
            // vm.modalRevendedora = false;
            
          }else{
            vm.revendedoras = response.data;
          }
        })
        .catch((error) => {
          vm.$swal("Atenção", "Falha ao carregar Revendedoras", "error");
        })
        .finally(() => {
          vm.loadingRevenda = false
        })
    },
    getProdutos() {
      const vm = this;
      const params = {
        // kitp: vm.kitP ? true : '',
        cashback: vm.cashback ? true : '',
        pedido_lancamento: vm.pedidoLancamento,
      }
      $(".loading").show();
      axios
        .get("/distribuidor/produtos/list", { params: params })
        .then((response) => {
          let produtos = response.data;
          produtos.forEach((produto) => {
            vm.produtos["" + parseInt(produto.codigo)] = {
              id: produto.id,
              campanha_produto_id: produto.pivot.id,
              codigo: produto.codigo,
              nome: produto.nome,
              preco: produto.pivot.preco,
              disponivel: produto.pivot.disponivel,
              disponivel_cd: produto.pivot.disponivel_cd,
              desconto: produto.pivot.desconto ? produto.pivot.desconto : 0.0,
              percentual: produto.pivot.percentual ? produto.pivot.percentual : 0.0,
            };

            if (vm.cash_back && vm.profile.distribuidor.codigo =='0664829') {
               let percDesconto = 0;
               if (produto.descontos.tipo_desconto == 'SEM_DESCONTO') {
                 percDesconto = 0;
               } else if (produto.descontos.tipo_desconto == 'FIXO' && produto.descontos.tipo_produto == 'ENCARTE') {
                 percDesconto = 30;
               } else if (produto.descontos.tipo_desconto == 'FIXO' && produto.descontos.tipo_produto == 'MR' && produto.descontos.valor_desconto_classe_ng == '10') {
                 percDesconto = 3;
               } else if (produto.descontos.tipo_desconto == 'FIXO' && produto.descontos.tipo_produto == 'MR' && produto.descontos.valor_desconto_classe_ng == '20') {
                 percDesconto = 13;
               } else if (produto.descontos.tipo_desconto == 'CLASSE') {
                 percDesconto = vm.profile.distribuidor.desconto ? vm.profile.distribuidor.desconto : 0;
               }
              //  console.log(produto.codigo)              
              //  console.log(produto.descontos.tipo_desconto)              
              //  console.log(vm.profile.distribuidor.desconto)              
              //  console.log(parseFloat(produto.pivot.preco))              
              //  console.log(vm.produtos["" + parseInt(produto.codigo)].preco = parseFloat(produto.pivot.preco - (produto.pivot.preco * percDesconto / 100)).toFixed(2))
               vm.produtos["" + parseInt(produto.codigo)].preco = parseFloat(produto.pivot.preco - (produto.pivot.preco * percDesconto / 100)).toFixed(2);
             }
          });
          vm.loadPedido();
        })
        .catch((error) => {
          //alert("Erro ao carregar Produtos");
          var e = error.response.data;
          vm.$swal(
            "Atenção",
            e.errors +
            " ou sua região não está vinculada a nenhum centro de distribuição",
            "error"
          );
          console.log(error);
        }).finally(() => {
          $(".loading").hide();
        });
    },
    getClasse() {
      var vm = this;
      axios.get("/distribuidor/produtos/getclasse").then(function (response) {
        vm.classe = response.data;
      });
    },

    loadEstoque() {
      const vm = this;
      $(".loading").show();
      axios
        .get("/distribuidor/estoque/listar")
        .then((response) => {
          let estoques = response.data;
          var estoqueLocal = {};
          if (estoques.length > 0) {
            estoques.forEach((estoque) => {
              let preco = estoque.preco;
              let total = preco * estoque.quantidade;
              let obj = {
                id: estoque.codigo,
                codigo: estoque.codigo,
                nome: estoque.nome,
                preco: parseFloat(preco).toFixed(2).replace(".", ","),
                quantidade: estoque.quantidade,
                total: total.toFixed(2).replace(".", ","),
              };
              estoqueLocal[estoque.codigo] = estoque.quantidade;
            });
          }
          vm.estoque = estoqueLocal;
          $(".loading").hide();
        })
        .catch((error) => {
          alert("Erro ao carregar Estoque");
          console.log(error);
          $(".loading").hide();
        });
    },
    async getCampanhaAtual() {
      const vm = this;
      await axios
        .get("/distribuidor/campanha/atual")
        .then((response) => {
          vm.campanhaAtual = response.data.campanha.codigo;
        })
        .catch((erro) => {
          console.log(erro);
        });
    },
    loadProdutosIncentivo() {
      axios.get("/produtos/incentivo").then((response) => {
        this.produtosIncentivo = response.data.produtos;
      });
    },
    /*################################## Fim dos métodos Load ########################################*/

    async savePedido() {
      const vm = this;
      if (!this.isBonificacao && !this.cash_back) {
        if (!this.validatePedidoMinimo() || !this.validateAllEstoque()) {
          return;
        }
      }
      let intDescontoPedido = parseInt(this.descontoDoPedido);
      if (intDescontoPedido < 0 || intDescontoPedido > 100) {
        this.$swal(
          "Atenção",
          "Não foi possível salvar as alterações, Este desconto é inválido",
          "error"
        );
        return;
      }
      if (
        vm.kitP &&
        (parseFloat(vm.valorTotal).toFixed(2) < (vm.profile?.distribuidor?.codigo === '1979103' ? 7000 : 7689.12) ||
          parseFloat(vm.valorTotal).toFixed(2) > 7789.12)
      ) {
        this.$swal(
          "Atenção",
          `Como este é o seu primeiro pedido personalizado, o valor total deve ser entre ${vm.profile?.distribuidor?.codigo === '1979103' ? 'R$ 7000,00' : 'R$ 7689,12'} e  R$ 7789,12`,
          "warning"
        );
        $(".loading").hide();
        return;
      }
      if (
        vm.cash_back &&
        parseFloat(vm.valorTotal).toFixed(2) > parseFloat(vm.cash_back.cashback)
      ) {
        this.$swal(
          "Atenção",
          "O valor desse pedido deve ser menor ou igual ao valor do Cash-Back R$"+vm.cash_back.cashback,
          "warning"
        );
        return;
      }
      if (
        (vm.campanhaAtual === "1-23" ||
          vm.campanhaAtual === "1F23" ||
          vm.campanhaAtual === "1D23") &&
        vm.classe === "G" &&
        !vm.kitP &&
        parseFloat(vm.valorTotal).toFixed(2) >= 200.0
      ) {
        if (this.produtosIncentivo.length <= 0) {
          this.loadProdutosIncentivo();
        }
        $(".loading").hide();
        this.saldoIncentivo = (parseFloat(vm.valorTotal) * 0.1).toFixed(2);
        const incentivo = this.saldoIncentivo.toString().replace(".", ",");
        this.$swal
          .fire({
            title: "Parabéns",
            html: `<span> Você ganhou R$ ${incentivo} em produtos! <br> 
                Adicione os produtos ao pedido </span>`,
            icon: "success",
            confirmButtonText: "Adicionar Brinde",
            confirmButtonColor: "#228B22",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            cancelButtonColor: "#B22222",
          })
          .then((result) => {
            if (result.isConfirmed) {
              vm.totalPedidoIncentivo = 0;
              vm.pedidosIncentivo = {};
              vm.pedidosIncentivoTable = [];
              vm.modalIncentivo = true;
              return;
            } else if (result.isDenied) {
              return this.confirmaSavePedido();
            }
          });
      } else {
        this.confirmaSavePedido();
      }
    },

    async confirmaSavePedido() {
      const vm = this;
      var error = "";
      let url = "/distribuidor/pedidos";

      let data = {
        itens: this.pedidos,
        revendedora: this.revendedora,
        desconto_do_pedido: this.descontoDoPedido,
        status: "ABERTO",
        enviar: vm.kitP ? true : false,
        bonificacao: this.isBonificacao,
        id: this.getIdPedido,
        kitP: this.kitP,
        pedido_estoque: this.pedidoEstoque,
        pedido_lancamento: this.pedidoLancamento,
        cash_back: this.cash_back ? this.cash_back.id : "",
      };

      /* if (vm.isBonificacao) {
        const btnSalva = await this.$swal.fire({
          title: "Após salvar, deseja enviar seu pedido ?",
          text: "Ao enviar seu pedido, o mesmo não mais poderá ser alterado.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Salvar e enviar",
          cancelButtonText: "Salvar e enviar depois",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        });

        $(".loading").show();
        if (btnSalva) {
          if (btnSalva.value) {
            data.enviar = true;
          }
          const response = await axios.post(url, data).catch((err) => {
            console.log("erro ao salvar");
            console.log(err.errors);
            var e = err.response.data;
            $(".loading").hide();
            if (e.errors) {
              if (Array.isArray(e.errors)) {
                vm.$swal("Atenção", e.errors[0], "error");
              } else {
                vm.$swal("Atenção", e.errors.toString(), "error");
              }
            }

            if (typeof err === "string") {
              console.log(JSON.parse(err));
            }
            console.log(`${error}`);
          });
          if (response) {
            window.location.href = "/distribuidor/pedidos?status=ABERTO";
          }
        }
        $(".loading").hide();
      } else*/
      if (vm.kitP || (vm.cash_back && vm.cash_back.id) || vm.pedidoEstoque || vm.pedidoLancamento) {
        const btnSalva = await this.$swal.fire({
          title: "Deseja salvar e enviar o pedido?",
          text: "Ao enviar seu pedido, o mesmo não mais poderá ser alterado.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Salvar e enviar",
          cancelButtonText: "Cancelar",
          showLoaderOnConfirm: true,
        });

        if (btnSalva) {
          if (btnSalva.value) {
            $(".loading").show();
            const response = await axios.post(url, data).catch((err) => {
              console.log("erro ao salvar");
              console.log(err.errors);
              var e = err.response.data;
              $(".loading").hide();
              if (e.errors) {
                //console.log("entrei dentreo de errors...");
                if (Array.isArray(e.errors)) {
                  vm.$swal("Atenção", e.errors[0], "error");
                } else {
                  vm.$swal("Atenção", e.errors.toString(), "error");
                }
              }

              if (typeof err === "string") {
                console.log(JSON.parse(err));
              }
              console.log(`${error}`);
            });

            if (response) {
              window.location.href = "/distribuidor/lote";
            }
          }
        }

        $(".loading").hide();
      } else {
        $(".loading").show();
        const response = await axios.post(url, data).catch((err) => {
          console.log(err.errors);
          var e = err.response.data;
          $(".loading").hide();
          if (e.errors) {
            if (Array.isArray(e.errors)) {
              vm.$swal("Atenção", e.errors[0], "error");
            } else {
              vm.$swal("Atenção", e.errors.toString(), "error");
            }
          }

          if (typeof err === "string") {
            console.log(JSON.parse(err));
          }
          console.log(`${error}`);
        });

        if (response) {
          $(".loading").hide();

          vm.$emit("pedido_id", response.data.pedido_id);
          vm.pedido_id_local = response.data.pedido_id;
          if (vm.incentivoAdicionado) {
            vm.$swal
              .fire({
                title: "Pedido salvo com sucesso!",
                icon: "success",
                showCancelButton: true,
                confirmButtonText: "Novo Pedido",
                cancelButtonText: "Ver pedidos Abertos",
                showCloseButton: true,
              })
              .then((result) => {
                if (!result.value) {
                  window.location.href = "/distribuidor/pedidos?status=ABERTO";
                } else {
                  window.location.href = "/distribuidor/pedidos/create";
                }
              });
          } else {
            vm.$swal
              .fire({
                title: "Parabéns!",
                text: "Pedido salvo com sucesso.",
                icon: "success",
                showDenyButton: true,
                denyButtonText: "Pedidos Abertos",

                showCancelButton: true,
                cancelButtonText: "Continuar Editando",

                confirmButtonText: "Novo Pedido",
                width: 700,
              })
              .then((result) => {
                if (result.isConfirmed) {
                  window.location.href = "/distribuidor/pedidos/create";
                } else if (result.isDenied) {
                  window.location.href = "/distribuidor/pedidos?status=ABERTO";
                }
              });

            /* vm.$swal
             .fire({
               title: "Pedido salvo com sucesso!",
               icon: "success",
               html:
                 "Para digitar um <b>novo pedido </b>, " +
                 '<a href="/distribuidor/pedidos/create"> clique aqui </a> ' +
                 "",
               showCancelButton: true,
               cancelButtonText: "Ver pedidos Abertos",
               confirmButtonText: "Continuar editando",
               showCloseButton: true,
             })
             .then((result) => {
               if (!result.value) {
                 window.location.href = "/distribuidor/pedidos?status=ABERTO";
                 //window.location.reload(1);
               }
             });*/
          }
          if ($("#pedido_status").val() === "ABERTO") {
            vm.loadEstoque();
          }
        }
      }
      //}
      //console.log(data);
    },

    addImportados() {
      this.adicionandoImportados = true;
      var vm = this;
      $(".loading").show();

      this.pedidosImportados.forEach(function (item) {
        if (
          typeof vm.produtos[item.codigo] !== "undefined" &&
          vm.produtos[item.codigo].disponivel === true
        ) {
          vm.codigo = item.codigo;
          vm.quantidade = item.quantidade;

          vm.addPedido();
          vm.clearAddProduto();
        }
      });

      this.pedidosImportados = [];
      vm.modalFileUpload = false;
      $(".loading").hide();
      this.adicionandoImportados = false;
      this.savePedido();
    },

    searchProduto() {
      // console.log(this.codigo);
      // console.log(this.produtos)
      const cd = this.profile.distribuidor ? this.profile.distribuidor.centro_distribuicao_id : null;
      // console.log(cd)
      this.erroProduto = false;
      if (this.codigo === 0 || this.codigo === "0") {
        this.labelProduto = "";
      } else if (typeof this.produtos[this.codigo] === "undefined" && this.codigo !== 0) {
        this.labelProduto = "Produto não Encontrado";
        this.erroProduto = true;
        $("#input-codigo-produto").focus();
      } else if (
        ((!this.produtos[this.codigo].disponivel &&
          !this.produtos[this.codigo].disponivel_cd) ||
          ((!cd || cd == 1) && !this.produtos[this.codigo].disponivel) ||
          (cd > 1 && !this.produtos[this.codigo].disponivel_cd))
      ) {
        if (this.getEstoqueDisponivel <= 0) {
          this.labelProduto = "Produto não disponível no estoque!";
        } else {
          this.labelProduto = this.produtos[this.codigo].nome;
        }
        this.erroProduto = true;
      } else {
        this.labelProduto = this.produtos[this.codigo].nome;
      }

      if (this.erroProduto) {
        this.quantidade = "";
        this.usarEstoque = 0;
      }
    },

    async confirmaAddPedido() {
      if (this.descontoDoPedido === null || this.descontoDoPedido === "") {
        this.descontoDoPedido = 0;
      }
      if (this.revendedora <= 0) {
        this.$swal("Atenção", "Selecione uma Revendedora", "error");
        return;
      }
      if (typeof (this.produtos[this.codigo]) === "undefined" || !this.produtos[this.codigo]) {
        return this.$swal("Atenção", "Código inválido", "error");
      }

      if (this.erroProduto == true) {
        if (!this.produtos[this.codigo].disponivel && this.quantidade > this.usarEstoque) {
          if (this.getEstoqueDisponivel <= 0) {
            this.$swal("Atenção", this.labelProduto, "error");
          } else {
            this.$swal("Atenção", 'Quantidade não disponível no estoque', "error");
          }
          $("#input-codigo-produto").focus();
          return;
        } else if (this.produtos[this.codigo].disponivel) {
          this.$swal("Atenção", 'Produto não disponível no estoque', "error");
          return;
        }
      }

      if (!this.produtos[this.codigo].disponivel && this.usarEstoque > this.getEstoqueDisponivel) {
        return this.$swal("Atenção", 'Quantidade utilizada do estoque, maior que o saldo disponível em estoque', "error");
      }

      if (
        this.codigo <= 0 ||
        typeof this.produtos[this.codigo] === "undefined"
      ) {
        this.$swal("Atenção", "Produto inválido ou não preenchido.", "error");
        $("#input-codigo-produto").focus();
        return;
      } else if (this.quantidade <= 0) {
        this.$swal("Atenção", "Adicione a quantidade de produtos.", "error");
        $("#input-quantidade").focus();
        return;
      }

      if (this.getEstoqueDisponivel <= 0) {
        this.usarEstoque = 0;
      }

      if (!this.validateEstoque()) {
        return;
      }

      let qtdAtual = 0;
      let aproveitadoEstoque = 0;

      if (typeof this.pedidos[this.codigo] !== "undefined") {
        qtdAtual = this.pedidos[this.codigo].quantidade;
        aproveitadoEstoque = this.pedidos[this.codigo].aproveitadoEstoque;
      }

      let pedido = {};
      pedido.codigo = this.codigo;
      aproveitadoEstoque += parseInt(this.usarEstoque);
      pedido.quantidade = parseInt(qtdAtual) + parseInt(this.quantidade);
      pedido.aproveitadoEstoque = aproveitadoEstoque;
      pedido.campanha_produto_id = this.produtos[this.codigo].campanha_produto_id;
      pedido.produto_id = this.produtos[this.codigo].id;
      pedido.desconto = this.produtos[this.codigo].desconto
        ? parseFloat(this.produtos[this.codigo].desconto).toFixed(2)
        : 0.0;
      pedido.percentual = this.produtos[this.codigo].percentual
        ? parseFloat(this.produtos[this.codigo].percentual).toFixed(2)
        : 0.0;

      this.$set(this.pedidos, this.codigo, pedido);
      this.pedidos[this.codigo].order = this.maxOrder++;
      if (this.usarEstoque > 0) {
        this.estoque[this.codigo] = this.estoque[this.codigo] - parseInt(this.usarEstoque);
      }
      this.clearAddProduto();
    },

    addPedido() {
      if (this.profile.codigo == '0680743' && this.quantidade > 10) {
        this.$swal({
          title: "Atenção",
          text: "Deseja realmente adicionar " + this.quantidade + " unidades do produto " + this.codigo,
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Sim, Adicionar",
          cancelButtonText: "Cancelar",
          showCloseButton: true,
        }).then((result) => {
          if (result.value) {
            this.confirmaAddPedido();
            result.value = false
          }
        });
      } else {
        this.confirmaAddPedido();
      }
    },

    addRevendedora() {
      const vm = this;
      this.revendedoraSelecionada = this.revendedoraSelecionadaModal;
      if (this.revendedora <= 0) {
        this.$swal("Atenção", "Selecione uma Revendedora", "error");
        return;
      }
      $(".loading").show();
      const data = { revendedora: vm.revendedora };
      axios
        .post("/revendedora/pedidoAberto", data)
        .then((response) => {
          if (response.data.length > 0) {
            if (vm.classe !== "G") {
              vm.pedidosAbertos = response.data;
              vm.modalPedidosAbertos = true;
              $(".loading").hide();
            } else {
              vm.editarPedido(response.data[0]);
            }
          } else {
            $(".loading").hide();
          }
        })
        .catch((error) => {
          $(".loading").hide();
          console.log(error);
          alert("Erro ao carregar pedido aberto");
        });

      vm.modalRevendedora = false;
      this.revendedora_id_local = parseInt(vm.revendedora);
      vm.descontoDoPedido = parseInt(
        vm.getRevendedoraById(vm.revendedora).desconto
      );
    },
    async updatePedido() {
      let estoque =
        typeof this.estoque[this.codigo] === "undefined"
          ? 0
          : parseInt(this.estoque[this.codigo]);

      /*if (this.usarEstoque > 0 && this.usarEstoque > this.estoqueDisponivel(this.codigo)) {
        this.$swal("Atenção", "Quantidade não disponível em estoque.", "error");
        this.usarEstoque = this.pedidos[this.codigo].aproveitadoEstoque;
        return;
      } else */
      if (this.usarEstoque > this.quantidade) {
        this.$swal(
          "Atenção",
          "O Uso do Estoque não pode ser maior que a Quantidade do pedido",
          "error"
        );
        return;
      } else if (this.quantidade <= 0) {
        this.$swal("Atenção", "Adicione a quantidade de produtos", "error");
        return;
      }

      if (this.usarEstoque > 0) {
        qtdEstoque = this.estoque[this.codigo] - parseInt(this.usarEstoque - this.pedidos[this.codigo].aproveitadoEstoque);
      } else {
        qtdEstoque = this.estoque[this.codigo] + parseInt(this.pedidos[this.codigo].aproveitadoEstoque);
      }
      if (qtdEstoque < 0) {
        return this.$swal("Atenção", "Quantidade utilizada em estoque inválida!", "error");
      }
      this.estoque[this.codigo] = this.estoque[this.codigo] - parseInt(this.pedidos[this.codigo].aproveitadoEstoque);
      this.pedidos[this.codigo].aproveitadoEstoque = parseInt(this.usarEstoque);

      var quantidadeAtual = parseInt(this.pedidos[this.codigo].quantidade);
      var usarEstoqueAtual = parseInt(
        this.pedidos[this.codigo].aproveitadoEstoque
      );

      this.pedidos[this.codigo].quantidade = parseInt(this.quantidade);
      let qtdEstoque = 0;


      if (this.validatePedidoMinimo()) {
        this.modalEdit = false;
        this.pedidos[this.codigo].order = this.maxOrder++;
        this.clearAddProduto();
        return;
      }
      this.pedidos[this.codigo].quantidade = quantidadeAtual;
      this.quantidade = quantidadeAtual;
      this.usarEstoque = usarEstoqueAtual;
      this.pedidos[this.codigo].aproveitadoEstoque = usarEstoqueAtual;
    },
    deletePedido() {
      const _pedidos = Object.assign({}, this.pedidos);
      if (_pedidos[this.codigo].aproveitadoEstoque && _pedidos[this.codigo].aproveitadoEstoque > 0) {
        this.estoque[this.codigo] += parseInt(_pedidos[this.codigo].aproveitadoEstoque)
      }
      delete _pedidos[this.codigo];
      this.pedidos = _pedidos;
      this.modalEdit = false;
      this.clearAddProduto();
    },
    showModalDestroyPedido() {
      const vm = this;
      this.$swal({
        title: "Realmente deseja deletar este pedido ?",
        text: "As alterações não salvas serão perdidas.",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim Deletar!",
        cancelButtonText: "Não, Sair.",
        showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          vm.destroyPedido();
        }
      });
    },
    destroyPedido() {
      var id = parseInt($("#pedido_id").val());
      let data = {
        _method: "DELETE",
      };

      axios
        .post("/distribuidor/pedidos/" + this.getIdPedido, data)
        .then(() => {
          window.location = "/distribuidor/pedidos?status=ABERTO";
        })
        .catch((error) => {
          console.log(error);
          alert("Erro ao Deletear");
        });
    },
    estoqueDisponivel(codigo) {
      return typeof this.estoque[codigo] !== "undefined" ? this.estoque[codigo] : 0;
      let emUso = typeof this.pedidos[codigo] !== "undefined" ? this.pedidos[codigo].aproveitadoEstoque : 0;
      if ($("#pedido_status").val() === "ABERTO") {
        return estoque + emUso;
      }
      return estoque - emUso;
    },

    keyUpValidateEstoque() {
      this.validateEstoque();
    },
    validateEstoque() {
      if (parseInt(this.usarEstoque) > parseInt(this.quantidade)) {
        this.$swal(
          "Atenção",
          "O Uso do Estoque não pode ser maior que a Quantidade do pedido",
          "error"
        );
        this.usarEstoque = 0;
        return false;
      } else if (
        parseInt(this.usarEstoque) >
        parseInt(this.estoqueDisponivel([this.codigo]))
      ) {
        this.$swal("Atenção", "Quantidade não disponível no Estoque.", "error");
        this.usarEstoque = 0;
        return false;
      }
      return true;
    },
    validateAllEstoque() {
      const vm = this;
      var retorno = true;
      var produto = "";

      if ($("#pedido_status").val() === "ABERTO") {
        return true;
      }

      /*for (let el in this.pedidos) {
        if (this.pedidos[el].aproveitadoEstoque && this.pedidos[el].aproveitadoEstoque > 0) {
          if (vm.estoque[el] - this.pedidos[el].aproveitadoEstoque < 0) {
            retorno = false;
            produto = this.produtos[el].codigo + ' - ' + this.produtos[el].nome;            
          }
        }
      }*/
      /*var produtos = Object.assign({}, this.pedidos);
      produtos.forEach((el) => {
        if (vm.estoque[el.codigo] - el.aproveitadoEstoque < 0) {
          retorno = false;
          produto = el.nome;
          return;
        }
      })*/

      if (!retorno) {
        this.$swal(
          "Atenção",
          "Verifique a disponibilidade de Estoque para o produto " + produto,
          "error"
        );
      }

      return retorno;
    },
    aproveitarTodoEstoque() {
      for (let codigo in this.pedidos) {
        if (
          typeof this.estoque[codigo] === "undefined" &&
          this.pedidos[codigo].aproveitadoEstoque > 0
        ) {
          this.pedidos[codigo].aproveitadoEstoque = 0;
          continue;
        } else if (typeof this.estoque[codigo] === "undefined") {
          continue;
        }

        if ($("#pedido_status").val() === "ABERTO") {
          var totalEstoque =
            parseInt(this.estoque[codigo]) +
            this.pedidos[codigo].aproveitadoEstoque;
        } else {
          var totalEstoque = parseInt(this.estoque[codigo]);
        }

        if (totalEstoque >= this.pedidos[codigo].quantidade) {
          this.pedidos[codigo].aproveitadoEstoque = parseInt(
            this.pedidos[codigo].quantidade
          );
        } else {
          this.pedidos[codigo].aproveitadoEstoque = totalEstoque;
        }
      }

      if (!this.validatePedidoMinimo()) {
        return;
      }
      this.maxOrder = this.maxOrder;
      this.savePedido();
    },
    limparUsoEstoque() {
      for (let codigo in this.pedidos) {
        if (
          typeof this.estoque[codigo] === "undefined" &&
          this.pedidos[codigo].aproveitadoEstoque > 0
        ) {
          this.pedidos[codigo].aproveitadoEstoque = 0;
          continue;
        } else if (typeof this.estoque[codigo] === "undefined") {
          continue;
        }

        this.pedidos[codigo].aproveitadoEstoque = 0;
      }

      this.savePedido();
    },
    showDeleteItem(codigo) {
      this.codigo = codigo;
      this.quantidade = this.pedidos[codigo].quantidade;
      this.usarEstoque = this.pedidos[codigo].aproveitadoEstoque;
      this.estoqueDisponivelEdit = this.estoqueDisponivel(codigo);
      this.searchProduto();
      const vm = this;
      vm.$swal
        .fire({
          title: "Realmente deseja deletar este item ?",
          text:
            vm.quantidade +
            " itens do produto: (" +
            vm.codigo +
            ") " +
            vm.labelProduto,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, Deletar",
          cancelButtonText: "Não, Cancelar",
        })
        .then((result) => {
          if (result.value) {
            vm.deletePedido();
          } else {
            vm.clearAddProduto();
          }
        });
    },
    showModalEdit(codigo) {
      this.modalEdit = true;
      this.codigo = codigo;
      this.quantidade = this.pedidos[codigo].quantidade;
      this.usarEstoque = this.pedidos[codigo].aproveitadoEstoque;
      this.estoqueDisponivelEdit = this.estoqueDisponivel(codigo);
      this.searchProduto();
    },
    showModalFileUpload() {
      var vm = this;
      this.pedidosImportados = [];
      vm.modalFileUpload = !vm.modalFileUpload;
    },
    changeFile(e) {
      this.filePedidos = null;
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      if (!this.validateExtension(files[0])) {
        return;
      }

      this.filePedidos = files[0];
    },
    sendFilePedidos() {
      var vm = this;
      if (this.filePedidos === null) {
        this.$swal("Atenção", "Anexe um arquivo válido", "error");
        return;
      } else if (!this.validateExtension(this.filePedidos)) {
        return;
      }
      var form = new FormData();

      form.append("pedidos", this.filePedidos);
      $(".loading").show();
      axios
        .post("/distribuidor/pedidos/interpreter", form)
        .then((response) => {
          vm.pedidosImportados = response.data;
          $(".loading").hide();
        })
        .catch((error) => {
          vm.$swal("Atenção", response.data.errors, "error");
          console.log(error);
          $(".loading").hide();
        });
    },
    clearAddProduto() {
      this.codigo = "";
      this.quantidade = "";
      this.labelProduto = "";
      this.usarEstoque = 0;

      $("#input-codigo-produto").focus();
    },
    validateExtension(file) {
      if (!file.name.match(/\.(csv|txt)$/i)) {
        this.$swal("Atenção", "Anexe um arquivo CSV ou TXT", "error");
        return false;
      }
      return true;
    },
    validatePedidoMinimo() {
      let totalItens = this.qtdItens - this.qtdAproveitadoEstoque;
      return validatePedidoMinimo(
        this.pedidoMinimo,
        this.pedidos,
        this.produtos,
        totalItens
      );
    },
    changeRevendedora(revendedora) {
      this.searchRevendedora = this.capitalize(revendedora.label)
      this.revendedoraSelecionadaModal = revendedora
      this.validaCadastro(revendedora)

      if(this.valido){
        this.addRevendedora()
      }
    },
    changeFocusCodigo() {
      if (typeof this.produtos[this.codigo] !== "undefined") {
        $("#input-quantidade").focus();
      }
    },
    goBack() {
      if (this.revendedoraSelecionada) {
        this.modalRevendedora = false;
      } else {
        window.history.back();
      }
    },
    addOrder() {
      const vm = this;
      $.each(vm.pedidos, function (index, pedido) {
        pedido.order = vm.maxOrder++;
      });
    },
    enviarPedido() {
      var vm = this;
      this.$swal
        .fire({
          title: "Deseja enviar este pedido ?",
          text: "Enviando o pedido, o mesmo não poderá ser reaproveitado.",
          icon: "question",
          showConfirmButton: true,
          confirmButtonText: "Sim, Enviar!",
          showCancelButton: true,
          cancelButtonText: "cancelar",
        })
        .then((result) => {
          if (result.value) {
            $(".loading").show();
            axios
              .post("/distribuidor/pedidos/enviar", {
                pedidos: [vm.getIdPedido],
              })
              .then(function (response) {
                window.location.href = "/distribuidor";
                $(".loading").hide();
              })
              .catch(function (error) {
                var errors = error.response.data.errors;

                if (typeof errors == "object") {
                  alert(errors.join("\n"));
                } else {
                  alert(errors);
                }

                $(".loading").hide();

                console.log(error);
              });
          }
        });
    },
    loadRevendedoraById(id) {
      const vm = this;
      $(".loading").show();
      return axios
        .get("/distribuidor/revendedora/" + id)
        .then((response) => {
          const revendedora = response.data;
          if (revendedora && revendedora.id) {
            vm.revendedoraSelecionada = {
              value: revendedora.id,
              label: revendedora.nome,
            };
            vm.revendedora_id_local = revendedora.id;
          } else {
            vm.modalRevendedora = true;
          }
        })
        .catch((error) => {
          console.log(error);
          vm.modalRevendedora = true;
        })
        .finally(() => {
          $(".loading").hide();
        });
    },
    getRevendedoraById(id) {
      var objRevendedora = null;
      this.revendedoras.forEach(function (revendedora, index) {
        if (revendedora.id === id) {
          objRevendedora = revendedora;
          return;
        }
      });
      return objRevendedora;
    },
    continuarEditando() {
      window.location = "/distribuidor/pedidos/" + this.getIdPedido + "/edit";
    },
    getProfile() {
      const vm = this;
      axios
        .get("/my-profile")
        .then((response) => {
          vm.profile = response.data.profile
        }).catch((error) => {
          console.log(error)
        });
    },
    validaCadastro(data) {
      if (data.value) {
        const revendedora = this.revendedoras.find(
          (rev) => rev.id === data.value
        );
        if (
          this.profile.codigo.indexOf(revendedora.codigo.replace("d", "")) > -1
        ) {
          this.valido = true;
          return;
        }
        if (this.classe === "G") {
          const cpf = revendedora.pessoa_fisica_id
            ? revendedora.pessoa_fisica.cpf
            : null;
          this.valido = validar(cpf);
        }
      }
    },
    async inicio() {
      if (this.cash_back && this.cash_back.pedido && this.cash_back.pedido.id) {
        window.location =
          "/distribuidor/pedidos/" + this.cash_back.pedido.id + "/edit";
        return;
      }
      this.getProfile();
      await this.validaKitPersonalizado();
      await this.loadEstoque();
      await this.getProdutos();
      await this.getClasse();
      await this.loadPedidoMinimo();
      this.getCampanhaAtual();
    },
  },
  computed: {
    pedidoEstoque(){
      return this.pedido_estoque == 1 ? true : false;
    },  
    pedidoLancamento(){
      return this.pedido_lancamento == 1 ? true : false;
    },  
    cpfIsValid() {
      return this.valido ? "success" : "danger";
    },
    estoqueDisponivelComputed() {
      var objEstoqueDisponivel = {};
      for (let codigo in this.pedidos) {
        let estoque = typeof this.estoque[codigo] !== "undefined" ? this.estoque[codigo] : 0;
        let emUso = typeof this.pedidos[codigo].aproveitadoEstoque !== "undefined" ? this.pedidos[codigo].aproveitadoEstoque : 0;
        if ($("#pedido_status").val() === "ABERTO") {
          objEstoqueDisponivel[codigo] = estoque;
        } else {
          objEstoqueDisponivel[codigo] = this.estoque[codigo]
          // objEstoqueDisponivel[codigo] = estoque - emUso;
        }
      }

      return objEstoqueDisponivel;
    },
    pedidosOrdered() {
      return _.orderBy(this.pedidos, "order", "desc");
    },
    qtdItens() {
      let total = 0;
      for (let codigo in this.pedidos) {
        total += this.pedidos[codigo].quantidade;
      }
      return total;
    },
    qtdAproveitadoEstoque() {
      let total = 0;

      for (let codigo in this.pedidos) {
        total += this.pedidos[codigo].aproveitadoEstoque;
      }

      return total;
    },
    valorTotal() {
      let total = 0;

      for (let codigo in this.pedidos) {
        if (this.produtos[codigo]) {
          total +=
            (parseFloat(this.produtos[codigo].preco) -
              parseFloat(this.produtos[codigo].desconto)) *
            parseInt(this.pedidos[codigo].quantidade);
        }
      }
      return total.toFixed(2).replace(".", ",");
    },
    qtdProdutos() {
      return Object.keys(this.pedidos).length;
    },
    getEstoqueDisponivel() {
      if (
        this.codigo === "" ||
        parseInt(this.codigo) === 0 ||
        typeof this.estoque[this.codigo] === "undefined" ||
        typeof this.estoque[this.codigo] === "undefined"
      ) {
        return 0;
      }

      if (
        typeof this.pedidos[this.codigo] === "undefined" ||
        $("#pedido_status").val() === "ABERTO"
      ) {
        return parseInt(this.estoque[this.codigo]);
      }

      return parseInt(this.estoqueDisponivel(this.codigo));
    },
    getIdPedido() {
      return this.pedido_id_local;
    },
    ObjListaDeRevendedoras() {
      var arrayRevendedoras = [];
      var vm = this;
      this.revendedoras.forEach(function (item, index) {
        if (item.ativa) {
          arrayRevendedoras.push({
            value: item.id,
            label: item.nome,
          });
        }
      });

      return arrayRevendedoras;
    },
    revendedora() {
      if (!this.revendedoraSelecionada) {
        return -1;
      }
      return this.revendedoraSelecionada.value;
    },
  },
  mounted() {
    this.inicio();
    $("#input-codigo-produto").focus();
  },
};
</script>

<style lang="scss" scoped>
.conteudo{
  text-align: center;
  font-weight: 900;
}

.label-search {
  margin: 2px;
  text-align: left !important;
  display: block;
}

.search-result {
  background: white;
  margin-top: 3px;
  z-index: 9;
  position: absolute;
  width: 94%;

  .custom-radius-top{
    border-radius: 5px 5px 0px 0px;
  }

  .custom-radius-bottom{
    border-radius: 0px 0px 10px 10px;
  }

  .result-list {
    padding: 10px 0px;
    cursor: pointer;
  }

  .result-list:hover {
    background: #e4e4e4;
    .product-name{
      -webkit-animation: scale-down-center 0.4s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
      animation: scale-down-center 0.4s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateY(-10px);
}

.pedido-cash {
  border-radius: 5px;
  color: white;
}

.container-btn {
  padding-top: 1.8em;
}

.preview-value {
  font-size: 1.3em;
}

.resumo-importacao {
  max-height: 400px;
  overflow-y: auto;
}

.codigos-nao-encontrados {
  max-height: 100px;
  overflow-y: auto;
}

.revendedora {
  background: rgba(1, 1, 1, 0.8);
  position: fixed;
  z-index: 99;
  height: 100%;
  width: 100%;
  top: 0px;
  left: 0px;
}

.revendedora>div {
  position: absolute;
  width: 90%;
  height: 40%;
  background: #fff;
  top: 30%;
  left: 5%;
  /*margin-top: -100px;*/
  /*margin-left: -150px;*/
  padding: 10px 10px 10px 10px;
  border-radius: 5px;
}

.first-row {
  background-color: rgba(255, 102, 106, 0.2) !important;
}

@-webkit-keyframes scale-down-center {
  0% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  100% {
    -webkit-transform: scale(0.99);
            transform: scale(0.99);
  }
}
@keyframes scale-down-center {
  0% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  100% {
    -webkit-transform: scale(0.99);
            transform: scale(0.99);
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/pedidos/create/Main.vue